export const enum userConstants {
  listUsersRequest = "LIST_USERS_REQUEST",
  listUsersSuccess = "LIST_USERS_SUCCESS",
  listUsersFailure = "LIST_USERS_FAILURE",
  listUsersReset = "LIST_USERS_RESET",
  
  listMembersRequest = "LIST_MEMBERS_REQUEST",
  listMembersSuccess = "LIST_MEMBERS_SUCCESS",
  listMembersFailure = "LIST_MEMBERS_FAILURE",
  
  listPhotographersRequest = "LIST_PHOTOGRAPHERS_REQUEST",
  listPhotographersSuccess = "LIST_PHOTOGRAPHERS_SUCCESS",
  listPhotographersFailure = "LIST_PHOTOGRAPHERS_FAILURE",
  
  inviteUserRequest = "INVITE_USER_REQUEST",
  inviteUserSuccess = "INVITE_USER_SUCCESS",
  inviteUserFailure = "INVITE_USER_FAILURE",
 
  viewUserRequest = "VIEW_USER_REQUEST",
  viewUserSuccess = "VIEW_USER_SUCCESS",
  viewUserFailure = "VIEW_USER_FAILURE",

  editUserRequest = "EDIT_USER_REQUEST",
  editUserSuccess = "EDIT_USER_SUCCESS",
  editUserFailure = "EDIT_USER_FAILURE",
  
  
  deleteUserRequest = "DELETE_USER_REQUEST",
  deleteUserSuccess = "DELETE_USER_SUCCESS",
  deleteUserFailure = "DELETE_USER_FAILURE",
  clearDeleteUserState = "CLEAR_DELETE_USER_STATE",
  
  processDeleteRequest = "PROCESS_DELETE_REQUEST",
  processDeleteSuccess = "PROCESS_DELETE_SUCCESS",
  processDeleteFailure = "PROCESS_DELETE_FAILURE",
  clearProcessDeleteState = "CLEAR_PROCESS_DELETE_STATE",
  
  listDeleteRequestsRequest = "LIST_DELETE_REQUESTS_REQUEST",
  listDeleteRequestsSuccess = "LIST_DELETE_REQUESTS_SUCCESS",
  listDeleteRequestsFailure = "LIST_DELETE_REQUESTS_FAILURE",
  
  revokeUserRequest = "REVOKE_USER_REQUEST",
  revokeUserSuccess = "REVOKE_USER_SUCCESS",
  revokeUserFailure = "REVOKE_USER_FAILURE",
  clearRevokeUserState = "CLEAR_REVOKE_USER_STATE",
  
  submitUpdateRequestRequest = "SUBMIT_UPDATE_REQUEST_REQUEST",
  submitUpdateRequestSuccess = "SUBMIT_UPDATE_REQUEST_SUCCESS",
  submitUpdateRequestFailure = "SUBMIT_UPDATE_REQUEST_FAILURE",
  clearSubmitUpdateRequestState = "CLEAR_SUBMIT_UPDATE_REQUEST_STATE",
  
  processUpdateRequestRequest = "PROCESS_UPDATE_REQUEST_REQUEST",
  processUpdateRequestSuccess = "PROCESS_UPDATE_REQUEST_SUCCESS",
  processUpdateRequestFailure = "PROCESS_UPDATE_REQUEST_FAILURE",
  clearProcessUpdateRequestState = "CLEAR_PROCESS_UPDATE_REQUEST_STATE",
  
  listUpdateRequestsRequest = "LIST_UPDATE_REQUESTS_REQUEST",
  listUpdateRequestsSuccess = "LIST_UPDATE_REQUESTS_SUCCESS",
  listUpdateRequestsFailure = "LIST_UPDATE_REQUESTS_FAILURE",

  viewKycdocumentRequest = "VIEW_KYCDOCUMENT_REQUEST",
  viewKycdocumentSuccess = "VIEW_KYCDOCUMENT_SUCCESS",
  viewKycdocumentFailure = "VIEW_KYCDOCUMENT_FAILURE",
}
